<template>
  <div class="GridItem" :style="'background-image:url(' + item.image + ')'">
    <a :href="item.url">
      <div class="xhoverScreen"></div>
      <span class="preview" @click.prevent="quickView()">
        <svg width="26px" height="17px" viewBox="0 0 26 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="home-and-interior" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="search---results---grid" transform="translate(-756.000000, -512.000000)" fill="#FFFFFF" fill-rule="nonzero">
                    <g id="eye" transform="translate(756.000000, 512.000000)">
                        <path d="M15.3987097,8.22580645 C15.3987097,9.38893548 14.4375484,10.3316129 13.2516129,10.3316129 C12.0656774,10.3316129 11.1045161,9.38893548 11.1045161,8.22580645 C11.1045161,7.06267742 12.0656774,6.12 13.2516129,6.12 C14.4375484,6.12 15.3987097,7.06267742 15.3987097,8.22580645 Z" id="Shape"></path>
                        <path d="M13.2516129,0.197419355 C6.27354839,0.197419355 0.637419355,8.22580645 0.637419355,8.22580645 C0.637419355,8.22580645 6.27354839,16.2541935 13.2516129,16.2541935 C20.2296774,16.2541935 25.8658065,8.22580645 25.8658065,8.22580645 C25.8658065,8.22580645 20.2296774,0.197419355 13.2516129,0.197419355 Z M13.2516129,12.3058065 C10.9703226,12.3058065 9.0916129,10.4632258 9.0916129,8.22580645 C9.0916129,5.9883871 10.9703226,4.14580645 13.2516129,4.14580645 C15.5329032,4.14580645 17.4116129,5.9883871 17.4116129,8.22580645 C17.4116129,10.4632258 15.5329032,12.3058065 13.2516129,12.3058065 Z" id="Shape"></path>
                    </g>
                </g>
            </g>
        </svg>
      </span>
      <span class="share" @click.prevent="toggleShare()">
        <svg width="19px" height="21px" viewBox="0 0 19 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="home-and-interior" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="search---results---grid" transform="translate(-808.000000, -510.000000)" fill="#FFFFFF">
                    <path d="M823.041667,522.923077 C822.348955,522.923077 821.709855,523.095552 821.124348,523.440504 C820.538841,523.78546 820.064671,524.235574 819.701821,524.790865 L815.471354,522.317308 C815.6033,522.048075 815.710504,521.762019 815.79297,521.459135 C815.875433,521.15625 815.916667,520.83654 815.916667,520.5 C815.916667,520.298077 815.900175,520.10036 815.867188,519.90685 C815.8342,519.71334 815.784721,519.52404 815.71875,519.338942 L820.147137,516.764423 C820.509983,517.168272 820.9388,517.48798 821.433595,517.723558 C821.928387,517.959136 822.464405,518.076923 823.041667,518.076923 C824.130215,518.076923 825.062063,517.681493 825.837238,516.890623 C826.612416,516.099757 827,515.149045 827,514.038462 C827,512.927878 826.612416,511.977166 825.837238,511.1863 C825.062063,510.39543 824.130215,510 823.041667,510 C821.953119,510 821.02127,510.39543 820.246095,511.1863 C819.470918,511.977166 819.083333,512.927878 819.083333,514.038462 C819.083333,514.240385 819.099825,514.438101 819.132812,514.631611 C819.1658,514.825122 819.215279,515.014422 819.28125,515.199519 L814.852863,517.774038 C814.490017,517.370189 814.0612,517.050482 813.566405,516.814904 C813.071613,516.579326 812.535595,516.461538 811.958333,516.461538 C810.869786,516.461538 809.937938,516.856968 809.16276,517.647838 C808.387583,518.438705 808,519.389417 808,520.5 C808,521.610583 808.387583,522.561295 809.16276,523.352162 C809.937938,524.143032 810.869786,524.538462 811.958333,524.538462 C812.403649,524.538462 812.82834,524.462742 813.232423,524.3113 C813.636505,524.159854 814.011717,523.957934 814.358071,523.70553 L819.132812,526.532454 C819.116321,526.59976 819.103948,526.671273 819.095702,526.746996 C819.087456,526.822716 819.083333,526.894232 819.083333,526.961538 C819.083333,528.072121 819.470918,529.022833 820.246095,529.813702 C821.02127,530.604571 821.953119,531 823.041667,531 C824.130215,531 825.062063,530.604571 825.837238,529.813702 C826.612416,529.022833 827,528.072121 827,526.961538 C827,525.850955 826.612416,524.900243 825.837238,524.109377 C825.062063,523.318507 824.130215,522.923077 823.041667,522.923077 Z" id="Page-1"></path>
                </g>
            </g>
        </svg>
      </span>

      <div class="text">
        <span class="category">{{ item.type_friendly !== undefined ? item.type_friendly : item.type|replace('_', ' ') }}</span>
        <h3>{{ item.title }}</h3>
        <span v-if="item.type === 'artifact' && item.date_historical_display" class="date artifactDate">Artifact Date: {{ item.date_historical_display }}</span>
        <span v-else-if="item.type === 'event' && item.date_historical_display" class="date eventDate">Event Date: July 17, 2018</span>
        <span v-else-if="item.type === 'news' && item.date_published" class="date publishedDate">Published Date: {{ item.date_published | date('%B %-d, %Y') }}</span>
        <span v-else class="date blankDate">&nbsp;</span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'GridItem',
  props: ['item'],
  mounted: function () {
    // console.log(this.item)
  },
  data () {
    return {
      // showShare: false
    }
  },
  methods: {
    quickView: function () {
      // console.log("quick view code goes here")
      this.broadcast('show-preview-modal', this.item.nid)
      // console.log(this.item)

    },
    toggleShare: function () {
      // console.log("share code goes here")
      // this.showShare = !this.showShare
      this.broadcast('show-share-modal', this.item)
    }
  }
};
</script>

<style scoped lang="scss">
  .GridItem {
    display: inline-block;
    height: 22vw;
    width: calc(25% - 9px);
    margin-right: 12px;
    margin-bottom: 12px;
    color: white;
    padding: 16px 0px;
    position: relative;
    overflow: hidden;
    background-color: $dark-blue;
    background-image: url('/themes/custom/microfiche/search/src/assets/artifact-bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @include bpFrom(2100px){
      width: calc(16.666666% - 10px);
      height: 15vw;
    }

    @include bpFromTo(1600px, 2100px){
      width: calc(20% - 10px);
      height: 19vw;
    }

    @include bpFromTo(800px, 1050px){
      width: calc(33.3333333% - 8px);
      height: 31vw;
    }

    @include bpFromTo(376px, 800px){
      width: calc(50% - 8px);
      height: 48vw;
    }

    @include bpFromTo(0px, 500px){
      width: 100%;
      height: 92vw;
      margin-right: 0;
      max-width: 360px;
      max-height: 360px;
    }

    &:nth-child(2n) {
      @include bpFromTo(376px, 800px){
        margin-right: 0;
      }
    }

    &:nth-child(3n) {
      @include bpFromTo(800px, 1050px){
       margin-right: 0;
      }

      @include bpFromTo(376px, 800px){
        margin-right: 12px;
      }
    }

    &:nth-child(4n) {
      margin-right: 0;

      @include bpFromTo(800px, 1050px){
       margin-right: 12px;
      }

      @include bpFrom(1600px){
        margin-right: 12px;
      }
    }

    &:nth-child(5n) {
      @include bpFromTo(1600px, 2100px){
        margin-right: 0;
      }
    }

    &:nth-child(6n) {
      @include bpFrom(2100px){
        margin-right: 0;
      }
    }

    a {
      display: block;

      &:after {
        content: '';
        height: 75%;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        // background: linear-gradient(rgba(4,27,52,0), rgba(1,11,22,.75), rgba(0,0,20,1));
        background-image: linear-gradient(-180deg, rgba(2,21,42,0.00) 0%, #041B35 100%);
        transition: opacity .4s ease;
      }
    }

    .hoverScreen {
      width: 100%;
      height: 500px;
      background: $pink;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      opacity: 0;
      transition: all .4s;
    }

    .preview {
      margin-left: 26px;
      margin-right: 16px;
      position: relative;
      z-index: 3;
      // top: -100px;
      left: -30px;
      opacity: 0;
      transition: all .4s;

    }

    .share {
      position: relative;
      z-index: 3;
      // top: -100px;
      left: -30px;
      opacity: 0;
      transition: all .4s;
    }

    &:hover {
      .hoverScreen {
        transition: all .4s;
        opacity: .85;
      }

      .preview, .share {
        // top: 0px;
        left: 0;
        opacity: 1;
        transition: all .4s;
      }
    }
    .text {
      padding: 26px;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 3;
      background-position: 0 25px;
      background-repeat: no-repeat;
      background-size: 100%;
      padding-top: 100px;

      .category {
        font-size: 18px;
        text-transform: uppercase;
        font-family: $gothic;
        padding-bottom: 8px;
        display: inline-block;
      }

      h3 {
        font-size: 20px;
        font-weight: bold;
        padding-bottom: 8px;
        //min-height: 54px;
      }

      .date {
        font-size: 16px;
        font-weight: 500;
      }
      .blankDate {
        display: none;
      }
    }
  }

  /**/
  .GridItem:after {
    content:'';
    width: 94px;
    height: 94px;
    bottom: 0;
    margin-left: -1px;
    left: 50%;
    transform: translate(-50%, 94px);
    background: $pink;
    border-radius: 50%;
    z-index: 2;
    position: absolute;
    transition: transform .5s ease, top .5s ease, opacity .5s ease;
  }

  .GridItem:hover {
    cursor: pointer;
    .filmstrip-tile__text {
      opacity: 1;
      visibility: visible;
    }

    .filmstrip-tile__title a {

      &:after {
        opacity: 1;
        transform: translatex(18px);
      }
    }

    .filmstrip-tile__image img {
      transform: scale(1.125);
    }

    &:after {
      transform: translate(-50%, -50%) scale(6);
      top: 50%;
      opacity: .88;

      // @include mq($from: 2050px) {
      //   transform: translate(-50%, -50%) scale(8);
      // }
    }

    .preview,
    .share {
      opacity: 1;
      transform: translatex(0);
    }
  }
</style>
